module.exports = __webpack_public_path__ + "img/border-de.4ff2ab38.svg";